const state = () => ({
  patients: null,
  patientsTotalCount: null,
})

const getters = {
  patients: (state) => state.patients,
  patientsTotalCount: (state) => state.patientsTotalCount,
}

const mutations = {
  receivePatients(state, patients) {
    state.patients = patients
  },
  appendPatients(state, patients) {
    const base = state.patients || []
    const seen = new Set(base.map((p) => p.id))
    const additions = patients.filter((p) => {
      if (seen.has(p.id)) {
        return false
      }
      seen.add(p.id)
      return true
    })
    state.patients = [...base, ...additions]
  },
  setPatientsTotalCount(state, count) {
    state.patientsTotalCount = count
  },
}

const actions = {
  getPatients({ commit, state, rootState }, payload) {
    const groupId = Number(payload.groupId)
    const offset = payload.offset != null ? payload.offset : 0
    const limit = payload.limit != null ? payload.limit : 27
    return this.$axios
      .post('/keto-app-backend/v1/core/patients/list', {
        accessToken: rootState.user.token,
        filters: {
          groupId,
        },
        offset,
        limit,
      })
      .then((response) => {
        if (response.data.success === false) {
          return
        }
        const newPatients = response.data.patients || []
        const countFromApi =
          response.data.count != null ? response.data.count : null
        const baseBefore = state.patients || []
        const baseLength = baseBefore.length

        if (offset > 0 && newPatients.length === 0) {
          commit('setPatientsTotalCount', baseLength)
          return
        }

        if (offset === 0) {
          commit('setPatientsTotalCount', null)
          commit('receivePatients', newPatients)
        } else {
          commit('appendPatients', newPatients)
        }

        if (countFromApi != null) {
          commit('setPatientsTotalCount', countFromApi)
          return
        }

        if (offset === 0) {
          commit('setPatientsTotalCount', newPatients.length)
        } else {
          commit('setPatientsTotalCount', (state.patients || []).length)
        }
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
